<div class="content-area" [class]="contentClass">
    <app-breadcrumb *ngIf="showBreadcrumb"></app-breadcrumb>
    <div class="content-wrapper" [class.no-scroll]="noScroll">
        <ng-content></ng-content>
    </div>
</div>
